import React from 'react';
import AbstractCard from '../abstractCard/abstractCard.jsx';
import { StyledContainer } from './printerCard.styles';

const PrinterCard = (props) => {
  return (
    <AbstractCard
      {...props}
      StyledLayoutContainer={StyledContainer}
      padding='0'>
      {props.children}
    </AbstractCard>
  );
};

export default PrinterCard;
